var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.732 28.191c7.504 0 13.61-6.105 13.61-13.609S38.236.972 30.732.972s-13.609 6.106-13.609 13.61 6.105 13.61 13.61 13.61Zm0-25.706c6.67 0 12.098 5.427 12.098 12.097s-5.427 12.097-12.098 12.097c-6.67 0-12.097-5.427-12.097-12.097S24.062 2.485 30.732 2.485Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.733 18.364a1.514 1.514 0 0 1-1.512-1.512.756.756 0 1 0-1.512 0c0 1.405.967 2.579 2.268 2.917v.107a.756.756 0 1 0 1.512 0v-.107a3.02 3.02 0 0 0 2.268-2.917 3.027 3.027 0 0 0-3.024-3.024 1.514 1.514 0 0 1-1.512-1.512c0-.834.678-1.513 1.512-1.513s1.512.678 1.512 1.513a.756.756 0 1 0 1.513 0 3.021 3.021 0 0 0-2.269-2.917V9.29a.756.756 0 1 0-1.512 0V9.4a3.02 3.02 0 0 0-2.268 2.917 3.027 3.027 0 0 0 3.024 3.024c.834 0 1.512.678 1.512 1.512s-.678 1.512-1.512 1.512Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.733 25.166c5.837 0 10.585-4.748 10.585-10.585 0-5.837-4.748-10.585-10.585-10.585-5.837 0-10.585 4.748-10.585 10.585 0 5.837 4.749 10.585 10.585 10.585Zm0-19.658c5.003 0 9.073 4.07 9.073 9.073s-4.07 9.073-9.073 9.073-9.073-4.07-9.073-9.073 4.07-9.073 9.073-9.073Z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.272 41.423c0-.625-.509-1.134-1.134-1.134-.625 0-1.134.509-1.134 1.134 0 .625.509 1.134 1.134 1.134.625 0 1.134-.509 1.134-1.134Z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.449 32.73c-.834-1.445-2.69-1.94-4.085-1.132l-8.701 4.235c-1.353.677-2.718.677-5.71.677-2.926 0-7.392-.739-7.438-.745a.755.755 0 1 0-.248 1.49c.188.032 4.634.767 7.685.767 3.14 0 4.715 0 6.38-.832l8.742-4.258c.349-.202.756-.255 1.147-.15.39.104.716.354.918.704.202.35.256.757.151 1.148-.104.39-.354.715-.725.93l-10.223 6.363c-.021.014-2.203 1.388-7.146 1.388-4.286 0-10.908-3.65-11.003-3.701-.069-.033-1.708-.836-4.874-.836a.756.756 0 1 0 0 1.512c2.75 0 4.166.662 4.17.662.285.158 7.03 3.875 11.707 3.875 5.459 0 7.88-1.573 7.96-1.627l10.186-6.34c.7-.403 1.2-1.055 1.409-1.835a3.002 3.002 0 0 0-.302-2.295Z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.319 29.704h6.048c.883 0 2.382 1.125 3.705 2.117 1.659 1.244 3.226 2.419 4.612 2.419h4.536c1.149 0 1.719.52 1.734.535a.754.754 0 0 0 1.07 0 .755.755 0 0 0 0-1.07c-.1-.1-1.03-.977-2.804-.977h-4.536c-.882 0-2.382-1.125-3.705-2.117-1.659-1.245-3.226-2.42-4.612-2.42h-6.049a.756.756 0 1 0 0 1.513Z",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.783 25.168H1.246a.756.756 0 1 0 0 1.512h4.537c.417 0 .756.34.756.756V44.07a.757.757 0 0 1-.756.756H1.246a.756.756 0 1 0 0 1.512h4.537A2.271 2.271 0 0 0 8.05 44.07V27.436a2.271 2.271 0 0 0-2.268-2.268Z",
    fill: "url(#g)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 30.732,
    y1: 0.973,
    x2: 30.732,
    y2: 28.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 30.733,
    y1: 8.535,
    x2: 30.733,
    y2: 20.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 30.733,
    y1: 3.996,
    x2: 30.733,
    y2: 25.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 3.138,
    y1: 40.289,
    x2: 3.138,
    y2: 42.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 27.709,
    y1: 31.211,
    x2: 27.709,
    y2: 44.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 20.904,
    y1: 28.191,
    x2: 20.904,
    y2: 34.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 4.271,
    y1: 25.168,
    x2: 4.271,
    y2: 46.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.03f37b6c266244ee93e8aa3eab72f488.svg";
export { ForwardRef as ReactComponent };